import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Shared/Common/Button';
import FileIcon from 'components/Shared/Common/FileIcon';
import { 
    StyledAction, 
    StyledFileContainer, 
    StyledFileBaseContent, 
    StyledFileBase, 
    StyledFileIcon, 
    StyledFileWrapper, 
    StyledFileActions 
} from './styles';
// import LinkTemplate from 'components/Shared/Common/LinkTemplate';

const GalleryFileItem = ({
    src,
    thumb,
    name,
    onDelete,
    author,
    date,
    onPreview,
    extension,
    isDisplayable
}) => {
    const handleDownload = useCallback((srcArg, nameAgr) => (e) => {
        e.stopPropagation();
        e.preventDefault();
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = srcArg;
        a.download = nameAgr;
        a.click();
        a.remove();
        return false;
    }, []);

    const handleDelete = useCallback(onDeleteArg => (e) => {
        e.stopPropagation();
        e.preventDefault();
        onDeleteArg();
    }, []);

    // todo : implement link item after rapi update
    /* const renderLinkTemplate = () => {
        return (
            <LinkTemplate
                title={name}
                subtitle={null}
                src={src}
                url={null}
                copyToClipboard={() => null}
            />
        );
    } */

    return (
        <StyledAction
            className="ui-list-files-item"
            onClick={onPreview}
        >
            <StyledFileContainer className="ui-file-container">
                <StyledFileBase className="ui-file-base">
                    <StyledFileActions className="s-file-actions">
                        {onDelete && (
                            <Button
                                onClick={handleDelete(onDelete)}
                                color="error"
                                iconName="Trash"
                                size="sm"
                            />
                        )}
                        <Button
                            onClick={handleDownload(src, name)}
                            color="secondary"
                            iconName="DownloadCloud"
                            size="sm"
                        />
                    </StyledFileActions>
                    <StyledFileWrapper className="ui-file-base-wrapper">
                        <StyledFileIcon className={isDisplayable ? 's-file-thumb' : 's-file-icon'}>
                            <FileIcon
                                name={name}
                                fileExtension={extension}
                                isDisplayable={isDisplayable}
                                src={src}
                                thumb={thumb}
                            />
                        </StyledFileIcon>
                        <StyledFileBaseContent className="ui-file-base-content">
                            <div className="text">
                                {name}
                            </div>
                            <div className="subtext">
                                {author} - {date}
                            </div>
                        </StyledFileBaseContent>
                    </StyledFileWrapper>
                </StyledFileBase>
            </StyledFileContainer>
        </StyledAction>
    );
};

GalleryFileItem.propTypes = {
    name: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    thumb: PropTypes.string,
    onPreview: PropTypes.func,
    onDelete: PropTypes.func,
    extension: PropTypes.string.isRequired,
    isDisplayable: PropTypes.bool.isRequired
};

export default GalleryFileItem;
